var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "help" } }, [
    _c(
      "div",
      { staticClass: "help-warp" },
      [
        _c(
          "div",
          { staticClass: "help-warp-tab" },
          [
            _c("nuxt-link", { attrs: { to: "/trait/help" } }, [
              _vm._v("首页 "),
              _c("i", [_vm._v("/")])
            ]),
            _c("span", [_vm._v(_vm._s(_vm.helpTypeName))])
          ],
          1
        ),
        _vm.helpTypeRows.length > 0
          ? _c(
              "div",
              { staticClass: "help-type-rows" },
              _vm._l(_vm.helpTypeRows, function(item, i) {
                return _c(
                  "a",
                  {
                    key: i,
                    class: _vm.typeId == item.type_id ? "active" : "",
                    attrs: { href: "javascript:;" },
                    on: {
                      click: function($event) {
                        return _vm.typeIdTo(item.type_id, 1)
                      }
                    }
                  },
                  [_vm._v(_vm._s(item.type_name))]
                )
              }),
              0
            )
          : _vm._e(),
        _c(
          "ul",
          { staticClass: "help-type-list" },
          _vm._l(_vm.helpList, function(item, i) {
            return _c(
              "li",
              { key: i },
              [
                _c(
                  "nuxt-link",
                  { attrs: { to: "/trait/help/detail/" + item.id } },
                  [_vm._v(_vm._s(item.problem_title))]
                ),
                _c("p", [
                  _c("span", [
                    _vm._v(_vm._s(item.update_time || item.create_time) + " ")
                  ]),
                  _c("span", [
                    _c("i", { staticClass: "el-icon-view" }),
                    _vm._v(_vm._s(item.view_num) + " ")
                  ])
                ])
              ],
              1
            )
          }),
          0
        ),
        _c("el-pagination", {
          attrs: {
            layout: "prev, pager, next",
            "page-size": 20,
            total: _vm.maxCount
          },
          on: { "current-change": _vm.currentChange }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4a2c71f4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// /opt/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a2c71f4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!/opt/node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/trait/help/_id.vue
// module id = pwR1
// module chunks = 5